module.exports = new __parcel__URL__("emptyStarBox.3b01bf42.svg").toString();